<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="secondary">FECHAR</button>
</mat-dialog-actions>
